function requestSubmit(form, submitter) {
  if (typeof form.requestSubmit === "function") {
    return form.requestSubmit(submitter);
  }
  if (submitter) {
    submitter.click();
  } else {
    submitter = document.createElement("input");
    submitter.type = "submit";
    submitter.hidden = true;
    form.appendChild(submitter);
    submitter.click();
    form.removeChild(submitter);
  }
}

export { requestSubmit };
//# sourceMappingURL=request-submit.js.map
